<template>
  <div v-if="company_phone_help_customer == 1">
    <div v-if="((company_phone1 != '') && (company_mobile1 != ''))" class="call_us_container call_us_container_width">
      <div class="call_us_btn">
        <h4 class="text-center contact-title">
          <a :href="`tel:${company_phone1}`">
            <i class="fa fa-phone"></i>
          </a>
          <a class="octopus-phone-number" v-if="company_phone1 != null" :href="`tel:${company_phone1}`" :data-countrycode="`${country_code}`"> {{company_phone1}} </a>
          <a class="octopus-phone-number" v-else-if="(company_phone1 == null) && (company_mobile1 != null)" :href="`tel:${company_phone1}`" :data-countrycode="`${country_code}`">{{company_mobile1}}</a>
        </h4>
        <h5 class="text-center">{{help_customer_available_hours}}</h5>
      </div>
    </div>
  </div>

</template>


<script>

import {getCompanyPhoneNumbers} from "@/modules/CustomerPortal/api/services/view";
export default {
  name: "CompanyPhonesNumbers",
  props: [
    "company_id"
  ],
  data() {
    return {
      company_phone_help_customer: 0,
      company_phone1: '',
      company_mobile1: '',
      help_customer_available_hours: '',
      country_key: '',
      country_code:'',
      // call_us_translate: '',
    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
    getCompanyPhoneNumbers(this.company_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
          this.company_phone_help_customer = response.data.company_phone_help_customer;
          this.company_phone1 = response.data.company_phone1;
          this.company_mobile1 = response.data.company_mobile1;
          this.help_customer_available_hours = response.data.help_customer_available_hours;
          this.country_key = response.data.country_key;
          this.country_code = response.data.country_code;
          // this.call_us_translate = response.data.call_us_translate;
        }
      }
    })
  }
}
</script>

<style>

.call_us_container_width {
  width: 29% !important;
  display: unset !important;
  float: right !important;
  margin-right: 50px !important;
  margin-top: 20px !important;
}
.call_us_container.call_us_container_width{
  width: 330px !important;
  z-index: 22222 !important;
  position: relative;
}
.call_us_btn{

  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
  padding: 8px 16px;
  font-family: sans-serif;
  border: none !important;
}


.octopus-phone-number {
  font-weight: bold;
  font-size: 16px;
}

.call_us_btn h5{
  font-size: 12px;
  color: #666;
}
@media (max-width: 767px) {
  .call_us_container_width {
    width: 106% !important;
    margin-right: 0 !important;
  }

}
.octopus-phone-number{
  color: inherit;
}
</style>
